import { useAPI } from '@axo/shared/data-access/provider';
import { QueryFunctionContext, useQuery } from 'react-query';
import {
  applicationKeys,
  parseApplicationKey,
} from '../../cache-keys/applicationKeys';
import { queryFunction } from '../../query-function';
import { application_registration_api } from '@axo/shared/data-access/api';

export const useRegistrationStatus = (applicationID: string) => {
  const api = useAPI();
  const cacheKey = applicationKeys.registrationStatus({
    applicationID,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      application_registration_api.getStatus(api),
      ({
        queryKey,
      }: QueryFunctionContext<
        ReturnType<(typeof applicationKeys)['registrationStatus']>
      >) => parseApplicationKey(queryKey).applicationID
    ),
    {
      enabled: !!applicationID,
    }
  );
};
